module.exports = __webpack_public_path__ + "img/ornament-850.b459bac0.png";